module.exports = __webpack_public_path__ + "static/media/Գետակի-վրա-Մարիետա-Բադալյան.813ea229.mp3";